import axios from "axios";
import apiEndpoints from "../config/apiEndpoints";
import { fetchData } from "../utils/utils";

export const fetchActivities = async (key, lang, id,date,totalCount) => {
  const endpoint = apiEndpoints.Activites.GET_ACTIVITIES(key, lang, id,date,totalCount);
  const result = await fetchData({ endpoint, method: "GET" });
  // console.log("result:",result)
  // if (!result.success) {
  //   console.error(result.message);
  // } else {
  //   console.log("Activities:", result);
  // }
  return result;
};

export const fetchClosedActivityDates = async (key) => {
  // Ensure all required parameters are provided
  const endpoint = apiEndpoints.Activites.GET_ACTIVITY_DAYS_CLOSED(key);
  const result = await fetchData({ endpoint, method: "GET" });
  if (!result.success) {
    console.error(result.message);
  } else {
    console.log("Activities Closed dates:", result);
  }
  return result;
};

export const fetchActivitesTime = async (payload) => {
    // Ensure all required parameters are provided
    const endpoint = apiEndpoints.Activites.GET_ACTIVITY_TIMES;
    const result = await fetchData({ endpoint, method: "POST",data:payload});
    if (!result.success) {
      console.error(result.message);
    } else {
      console.log("Activities times:", result);
    }
    return result;
  };

  export const CreateActivity = async (payload) => {
    // Ensure all required parameters are provided
    const endpoint = apiEndpoints.Activites.CREATE_ACTIVITY_RESERVATION;
      const result = await fetchData({ endpoint, method: "POST", data: payload });
    if (result?._links?.checkout?.href) {
        window.parent.postMessage(
            {
                redirectUrl: result?._links?.checkout?.href,
            },
            "*"
        );
    } else {
        console.error("Failed to create activity:", result?.message || "Unknown error");
    }
    return result;
  };

  export const getCombinationList=async(payload)=>{
    const endpoint = apiEndpoints.Activites.GET_COMBINATION_LIST
    const result = await fetchData({ endpoint, method: "Post",data:payload });
    if (!result.success) {
      console.error(result.message);
    } else {
      console.log("Combination List:", result);
    }
    return result;
  }

  export const fetchAvailableLocation = async (params) => {
    try {
        const response = await axios.post(apiEndpoints.Activites.GET_AVAILABLE_LOCATION,params);
        return response;
    } catch (error) {
        console.error("Error fetching available location", error?.message);
        return null;
    }
};



